import searchlineLogo from '@/assets/searchline-logo.jpg'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Settings, LogOut } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

const navItems = [
  { label: 'Projects', to: '/' },
  { label: 'New Project', to: '/new-project' },
]

// Auth screens render without the shell nav — just the full-page layout
const AUTH_PATHS = ['/login', '/signup', '/forgot-password']

export const AppLayout = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { signOut } = useAuth()
  const isAuthPage = AUTH_PATHS.includes(location.pathname)

  const handleLogout = async () => {
    await signOut()
    navigate('/login')
  }

  if (isAuthPage) {
    return <Outlet />
  }

  return (
    <div className="min-h-screen bg-[#02182B] text-white">
      {/* Top nav header */}
      <header className="border-b border-[#233D4C] bg-[#02182B] sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={searchlineLogo} alt="Searchline" className="w-7 h-7 rounded-md" />
            <div>
              <span className="text-white font-semibold text-sm">Searchline Engine</span>
              <span className="text-gray-400 text-xs ml-2">AI Hiring</span>
            </div>
          </div>
          <nav className="flex items-center gap-1 overflow-x-auto">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-lg text-sm transition-colors ${
                    isActive
                      ? 'bg-[#FD802E]/10 text-[#FD802E] font-medium'
                      : 'text-gray-400 hover:text-white hover:bg-[#233D4C]'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}

            <div className="ml-2 h-5 w-px bg-[#233D4C]" />

            <NavLink
              to="/settings"
              title="Settings"
              className={({ isActive }) =>
                `p-2 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-[#FD802E]/10 text-[#FD802E]'
                    : 'text-gray-400 hover:text-white hover:bg-[#233D4C]'
                }`
              }
            >
              <Settings size={17} />
            </NavLink>

            <button
              onClick={handleLogout}
              title="Sign out"
              className="p-2 rounded-lg transition-colors text-gray-400 hover:text-white hover:bg-[#233D4C]"
            >
              <LogOut size={17} />
            </button>

            <div className="ml-2 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-green-400" />
              <span className="text-xs text-gray-400">Live</span>
            </div>
          </nav>
        </div>
      </header>
      {/* Page content */}
      <main className="min-h-[calc(100vh-65px)]">
        <Outlet />
      </main>
    </div>
  )
}
